import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { PxCaptchaTypes } from "../types";
import { createAsyncThunk } from '@reduxjs/toolkit';
import { notificationsRioEvent } from "../../lib/rio/rioEvents";
import { trigger as clientCallback } from "../../lib/clientCallback";
import { EventTypes, recordEvents } from "../../utils/newRelicEvents";
import { isPxError, sendResetPasswordEmail } from '@chegg/one-auth-sdk';
import { hashEmail } from "../../utils/hashEmail";
import { getTexts } from "../../lib/contentful/defaultTexts";
import { initiatePx } from "../../utils/pxUtils";
export var sdkResetPasswordReducers = {
  rejected: function rejected(state, action) {
    var _ref = action.payload,
      error = _ref.error,
      hashedEmail = _ref.hashedEmail;
    var clientId = state.clientId;
    sendNotificationsRioEvent(error === null || error === void 0 ? void 0 : error.code);
    if (!isPxError(error)) {
      state.resetPassword.loading = false;
      state.resetPassword.credentials.error = getTexts().resetPassword.genericError;
      recordEvents(_defineProperty({}, EventTypes.resetPasswordFail, {
        clientId: clientId,
        email: hashedEmail,
        error: (error === null || error === void 0 ? void 0 : error.message) || getTexts().resetPassword.genericError,
        isCriticalError: error === null || error === void 0 ? void 0 : error.criticalError
      }));
      return;
    }
  },
  pending: function pending(state) {
    state.resetPassword.loading = true;
  },
  fulfilled: function fulfilled(state) {
    state.resetPassword.loading = false;
    state.resetPassword.successScreen = true;
    state.resetPassword.credentials.error = '';
  }
};
export var sdkResetPassword = createAsyncThunk('oneauth/sdkResetPassword', async function (_, _ref2) {
  var getState = _ref2.getState,
    dispatch = _ref2.dispatch,
    rejectWithValue = _ref2.rejectWithValue;
  var state = getState();
  var env = state.env,
    clientId = state.clientId,
    email = state.resetPassword.credentials.email.value;
  var hashedEmail = await hashEmail(email);
  recordEvents(_defineProperty({}, EventTypes.resetPasswordStart, {
    clientId: clientId,
    email: hashedEmail
  }));
  try {
    var response = await sendResetPasswordEmail(clientId, email);
    recordEvents(_defineProperty({}, EventTypes.resetPasswordSuccess, {
      clientId: clientId,
      email: hashedEmail
    }));
    clientCallback({
      type: 'auth',
      payload: {
        action: 'reset_password',
        status: 'success',
        data: response
      }
    });
  } catch (e) {
    var error = e;
    clientCallback({
      type: 'auth',
      payload: {
        action: 'reset_password',
        status: 'error',
        errors: error,
        data: {}
      }
    });
    if (isPxError(error)) {
      initiatePx(env, error, dispatch, clientId, PxCaptchaTypes.RESET_PASSWORD, 'email/password', false, function () {
        dispatch(sdkResetPassword());
      });
    }
    return rejectWithValue({
      error: error,
      hashedEmail: hashedEmail
    });
  }
});
function sendNotificationsRioEvent(errorCode) {
  var message_detail = getTexts().resetPassword.genericError;
  var message_id = 'reset password sdk: genericError';
  notificationsRioEvent({
    notifications: {
      message_id: message_id,
      type: 'error',
      message_detail: message_detail,
      message_name: 'reset password error'
    }
  });
}